import React, { useState, useEffect, Component, useRef, forwardRef, useImperativeHandle } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGame";
import Calculator from "../../components/Calculator";
import useGame from "../../hooks/useGame";
import useRatingQuestions from "../../hooks/useRatingQuestions";
//import openClient from 'socket.io-client';
import { LioWebRTC } from 'react-liowebrtc';
import { withWebRTC } from 'react-liowebrtc';
import ChatBox from '../../components/ChatBox'
import codeBackground from "../../assets/background.png"
import useUsername from "../../hooks/useUsername";
import ListItem from '@material-ui/core/ListItem';
import { navigate } from "@reach/router";//this is for the back button
import { Scale } from 'react-scaling';

//gamemodes
import MultiplyDivide from "./MP_MultiplyDivide";
import Addition from "./MP_Addition";
import Fractions from "./MP_Fractions";
import Spelling from "./MP_Spelling";
import NumPlace from "./MP_NumPlace";
import RomanNumerals from "./MP_RomanNumerals";
import Algebra from "./MP_Algebra";
import Grammar from "./MP_Grammar";
import Geometry from "./MP_Geometry"
import Measurements from "./MP_Measurements"
import Statistics from "./MP_Statistics"
import Phonics from "./MP_Phonics"
import NumberSense from "./MP_NumberSense"
import Ratios from "./MP_Ratios"
import MathsVocab from "./MP_MathsVocab"
import games from "../../game_data";

//addblocker thing
//import DetectAdBlock from "./DetectAdBlock.js"

function makeid(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNPQRSTUVWXYZ';
  var numbers = '123456789'
  var letter = true;

  for (var i = 0; i < length; i++) {
    if (letter)
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    else
      result += numbers.charAt(Math.floor(Math.random() * numbers.length));
    letter = !letter;
  }
  return result;
}

var details;
var gamestart = false;

export default function Start({ ...props }) {
  details = useUsername();
  gamestart = false;

  useEffect(() => {
    if (details.details !== undefined) {
      console.log(details);
      details.details.username = details.details.school_id;
    }
  }, [details]);

  // <CodeEntry {...props} />
  return (
    <div>
      <Scale scaleTo={1720}>
        <ChooseMode {...props} />
      </Scale>
    </div>
  )
}

class ChooseMode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: ""
    };
  }

  ChallengeMode() {
    this.setState({ mode: "Challenge" });
  }

  WorldMode() {
    this.setState({ mode: "World" });
  }

  BackToModeSelect() {
    this.setState({ mode: "" })
    console.log("return to mode select")
  }

  render() {
    return (
      <div>
        <BodyCode style={{ display: this.state.mode == "" ? 'flex' : 'none' }}>
          <Frame style={{ height: "400px" }}>
            <br></br>
            <h2 style={{ alignSelf: "center", fontSize: "3em" }}>Choose Mode</h2>
            <h2 style={{ alignSelf: "center", fontSize: "2em" }}><i>Maximum of 8 players.</i></h2> 
            <br></br><br></br>
            <Button style={{
              alignSelf: "center",
              width: "400px",
              height: "100px",
              lineHeight: "70px",
              fontSize: "3em"
            }} onClick={this.ChallengeMode.bind(this)}>Classmate Challenge</Button>
            <Button style={{
              alignSelf: "center",
              width: "400px",
              height: "100px",
              lineHeight: "70px",
              fontSize: "3em"
            }} onClick={this.WorldMode.bind(this)}>Versus the World</Button>
          </Frame>
        </BodyCode>
        <Buttonz onClick={() =>{navigate(".")}}>Back</Buttonz>
        {this.state.mode == "Challenge" ? (
          <div>
            <CodeEntry
              goBack={this.BackToModeSelect.bind(this)}
              {...this.props} />
          </div>

        ) : (
            <div></div>

          )}
        {this.state.mode == "World" ? (
          <div>
            <VersusTheWorld
              goBack={this.BackToModeSelect.bind(this)}
              {...this.props} />
          </div>
        ) : (
            <div></div>
          )}
      </div>
    )
  }
}

class VersusTheWorld extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      value: props.value || "",
      codeInput: false,
      host: false,
      header: true,
      update: false,
      inRoom: false,
      roomNum: 1,
      searching: true,
      started: false,
      countDown: 15,
      hostTime: null
    };
    this.child = React.createRef();
    this.scores = [];
    this.bots = [];
    this.full = [];//this is a boolean list of full rooms, they are full if count = 8
    this.loadingText = "Searching";
    this.HideHeader = this.HideHeader.bind(this);
    this.stopbots = false;
  }

  componentDidMount() {
    console.log("sets up versus the world")
    console.log(this.props);
    this.interval = setInterval(() => this.SetLoadingText(), 500);

  }

  componentWillUnmount() {
    clearInterval(this.interval);
    clearInterval(this.count);
  }

  //this is the AI of the bots, it contains a loop inside it which is done with the "settimeout" command
  BotAI() {
    //this2 is required because within the function it does not know what 'this' is
    var this2 = this;

    var EasyBot = function () {
      console.log("easy bot call" + this2.stopbots);
      var possibleScores = [10, 20]
      //console.log(this2);
      var easyBot = this2.bots[0]
      //console.log(easyBot);
      easyBot.score += possibleScores[Math.floor(Math.random() * possibleScores.length)]
      var randDelay = Math.floor(Math.random() * (7000 - 3000)) + 3000;
      //console.log(randDelay);
      if (this2.child.current != null && this2.stopbots == false) {
        this2.child.current.webrtc.shout('bots', JSON.stringify(this2.bots))
        this2.setState({ update: !this2.state.update });
        setTimeout(EasyBot, randDelay);
      }
    }

    var HardBot = function () {
      var possibleScores = [10, 20, 40]
      //console.log(this2);
      var hardBot = this2.bots[1]
      //console.log(hardBot);
      hardBot.score += possibleScores[Math.floor(Math.random() * possibleScores.length)]
      var randDelay = Math.floor(Math.random() * (5000 - 3000)) + 3000;
      //console.log(randDelay);
      if (this2.child.current != null && this2.stopbots == false) {
        this2.child.current.webrtc.shout('bots', JSON.stringify(this2.bots))
        this2.setState({ update: !this2.state.update });
        setTimeout(HardBot, randDelay);
      }
    }
    //starts the loop function
    EasyBot();
    //another one for hard bot
    HardBot();
  }

  //this displays "loading..." on the screen
  SetLoadingText() {
    this.loadingText += "."
    if (this.loadingText == "Searching....")
      this.loadingText = "Searching";
    if (this.state.searching == false)
      clearInterval(this.interval);
  }

  CountDownToStart() {
    this.setState({ countDown: this.state.countDown - 1 })
    //console.log(this.state.countDown);
    if (this.state.countDown <= 0) {
      //start game
      this.setState({ started: true })
      console.log("Start the Game")
      //sends start game to everyone if host
      if (this.state.host == true) {
        this.child.current.webrtc.shout('start', "");
        //starts the bots
        this.stopbots = false;
        console.log("start bots");
        this.BotAI();
      }
      this.SetScore(0);
      clearInterval(this.count);
    }
  }

  //this is done on join
  checkIfEmpty = () => {
    console.log("I joined a room");
    console.log(this.props);
    console.log(details);
    console.log(this.child.current.webrtc);
    //get amount of people in room
    var count = this.child.current.webrtc.roomCount;
    //sets nickname
    this.child.current.webrtc.webrtc.config.nick = details.details.school_id;
    //if the room is empty and you aren't the host then disconnect
    if (count == 1 && this.state.host == false) {
      this.full[this.state.roomNum] = false;
      this.NextRoom();
    }
    else {
      if (count < 8) {
        if (this.full[this.state.roomNum]) {
          this.NextRoom();
          console.log("ingame")
        } else {
          this.setState({ scores: [] })
          this.setState({ readyToStart: true })
          this.setState({ searching: false })
          if (this.state.started != true) {
            this.SetScore(-1)
            clearInterval(this.count);
            this.count = setInterval(() => this.CountDownToStart(), 1000);
          }
          if (this.state.host == true) {
            console.log("create bots");
            this.CreateBots();
          }
        }
      } else {
        this.full[this.state.roomNum] = true;
        this.NextRoom();
        console.log("full")
      }
    }
  }

  CreateBots() {
    this.bots = [];

    let Names = ["Yasser", "Andrew", "Ryan", "Sam", "Glen", "Maria", "Naomi", "Phil", "Justin", "Tracey", "Morgan",
      "Chris", "James", "Bob", "Billy", "David", "Charlie", "Ron", "Emily", "Aimee", "Josh", "Leona", "Michael", "Fiona", "Jordan",
      "Lisa", "Charlotte", "Simon", "Emma", "Jenna", "Julius", "William", "Henry", "Harry", "Borris", "Tony", "Michelle", "Lesley",
      "Matthew", "Dan", "Sean", "Scott", "Jon", "Homer", "Oliver", "Felix", "Arthur", "Joseph", "Jeremy", "Theresa", "May", "June", "Sara", "Pauline",
      "Heather", "Anne", "Frank", "Carol", "Joe", "Jo", "Amy", "Nicky", "Martha", "April", "Jim", "Tom", "Mike", "Jack", "Jay", "Wally", "Waldo", "Rupert"]
    for (let i = 0; i < 2; i++) {
      let randomName = Names[(Math.floor(Math.random() * Names.length))]
      let botObject = {
        username: (-i),
        name: randomName,
        score: 0
      }
      this.bots.push(botObject);
    }
    console.log(this.bots);
  }

  handleCreatedPeer = (webrtc, peer) => {
    //this.addChat(`Peer-${peer.id.substring(0, 5)} joined the room!`, ' ', true);
    //this.props.webrtc.shout('playerid', "test")
    console.log(this.child.current.webrtc.getPeers());
    console.log(this.child)
    //sets nickname
    this.child.current.webrtc.webrtc.config.nick = details.details.school_id;
    this.setState({ update: true })
    this.setState({ readyToStart: false })
    this.WaitForJoin();
    console.log(this.state.host);

  }

  //this method adds the score that was sent to this player into the scores list, this makes it so both are sync
  ParseOnlineScore(usernam, score) {
    var scoreObject = {
      username: usernam,
      score: parseInt(score, 10)
    }

    //find if score exists else create one
    var found = false;
    for (var i = 0; i < this.scores.length; i++) {
      if (this.scores[i].username == usernam) {
        this.scores[i].score += score;
        found = true;
      }
    }
    if (found == false)
      this.scores.push(scoreObject)

    console.log(this.scores);
  }

  //this method adds the score that was sent to this player into the scores list, this makes it so both are sync
  ParseOnlineSetScore(usernam, score) {
    var scoreObject = {
      username: usernam,
      score: parseInt(score, 10)
    }

    //find if score exists else create one
    var found = false;
    for (var i = 0; i < this.scores.length; i++) {
      if (this.scores[i].username == usernam) {
        this.scores[i].score = score;
        found = true;
      }
    }
    if (found == false)
      this.scores.push(scoreObject)

    console.log(this.scores);
  }

  WaitForJoin() {
    setTimeout(() => {
      console.log("timer done");
      this.setState({ update: true })
      this.setState({ readyToStart: true })
      if (this.state.started != true)
        this.SetScore(-1)
      //IF HOST THEN submit the timer to them
      if (this.state.host == true) {
        if (this.state.started != true) {
          this.child.current.webrtc.shout('timer', this.state.countDown);
          this.child.current.webrtc.shout('bots', JSON.stringify(this.bots));
        }
        //this.child.current.webrtc.shout('next', JSON.stringify(this.state.hostTime));
        console.log(this.state.started);
        if (this.state.started == true)
          this.child.current.webrtc.shout('ingame', "blank");
      }
    }, 1500)
  }

  handlePeerData = (webrtc, type, payload, peer) => {
    console.log(peer);
    console.log(type);
    console.log(payload);
    console.log(this.count);
    switch (type) {
      case 'chat':
        this.addChat(`Peer-${peer.id.substring(0, 5)}`, payload);
        break;
      case 'playerID':
        console.log("joined")
        break;
      case 'timer':
        if (this.count != null) {
          this.setState({ countDown: parseInt(payload, 10) })
          console.log(parseInt(payload, 10));
          console.log(payload);
          console.log(this.state.countDown);
          clearInterval(this.count);
          this.count = setInterval(() => this.CountDownToStart(), 1000);
          console.log("TIMER GOT")
        }
        break;
      case 'start':
        gamestart = true;
        this.setState({ started: true });
        this.SetScore(0);
        console.log("host sent start game");
        break;
      case 'next':
        if (this.state.started == false) {
          //goes to next room if there is already a host
          console.log("move to next room")
          this.HostNextRoom(payload);
        }
        break;

      case 'score':
        //parse the payload by adding it to the score
        this.ParseOnlineScore(peer.nick, payload);
        this.setState({ update: !this.update })
        break;
      case 'setscore':
        //parse the payload by setting the score
        this.ParseOnlineSetScore(peer.nick, payload);
        this.setState({ update: !this.update })
        break;

      case 'bots':
        this.bots = JSON.parse(payload);
        console.log(this.bots);
        this.setState({ update: !this.state.update });
        break;
      case 'ingame':
        console.log("received in game");
        if (this.state.started == false) {
          this.SkipRoom();
        }
        break;
      default:
        return;
    };
  }

  //this goes onto host the next room
  HostNextRoom(date) {
    return;
    //compare date
    console.log(this.state.hostTime);
    var otherDate = JSON.parse(date);
    console.log(otherDate);
    if (this.state.host) {
      if (JSON.parse(date) < this.state.hostTime) {
        console.log("stop being the host")
        this.setState({ host: false })
        this.scores = [];
        this.bots = [];
        this.setState({ roomNum: this.state.roomNum })
        this.setState({ searching: true })
        this.setState({ started: false })
        this.setState({ countDown: 15 })
        this.setState({ hostTime: null })
        this.stopbots = true;
        clearInterval(this.count);
        this.WaitToJoin();

      }
    }
  }

  //already ingame so go to next server
  SkipRoom() {
    console.log("this room is ingame, skip room")
    //search through next room
    //set current room to full
    this.full[this.state.roomNum] = true;
    //search through the rest of the rooms
    //this.NextRoom();
    //this.child.current.webrtc.leaveRoom();//DO I HAVE TO LEAVE ROOM?
    //clear data
    this.scores = [];
    this.bots = [];
    this.setState({ started: false })
    //reset countdown
    this.setState({ countDown: 15 })
    this.setState({ roomNum: this.state.roomNum + 1 })

    this.NextRoom();
  }

  DisplayUsernames() {
    const numbers = [1, 2, 3, 4, 5];
    //console.log(this.child.current.webrtc.peers);
    //console.log(this.child.current.webrtc.getPeers())
    var peers = this.child.current.webrtc.getPeers();
    var list = [];
    //push your name
    list.push(details.details.school_id);
    if (peers != undefined && peers.length > 0) {
      for (let index = 0; index < peers.length; index++) {
        //console.log(peers[index])
        //console.log(peers[index].id)
        //console.log(peers[index].nick)
        //console.log(peers[index].type)
        list.push(peers[index].nick);
      }
    }

    for (let index = 0; index < this.bots.length; index++) {
      list.push(this.bots[index].name);
    }
    //console.log("usernames");
    //console.log(list);

    const listItems = list.map((i) =>
      <li style={{ fontSize: "2em" }}>{i}</li>
    );
    return listItems;
  }

  NextRoom() {
    this.child.current.webrtc.leaveRoom();
    console.log("Disconnecting")
    //connect to next one or create a new one from the start
    if (this.state.roomNum != 35) {//AMOUNT OF ROOMS
      this.state.roomNum += 1;
      this.WaitToJoin();
    } else {
      console.log("searched through " + this.state.roomNum + " rooms")
      //goes through full rooms and then creates one for a none full room
      this.state.host = true;
      this.state.roomNum = 1;
      this.setState({ hostTime: new Date() })
      console.log(new Date())
      //then checks empty rooms first before joining one
      var allFull = true;
      console.log(this.full);
      for (let i = 0; i < this.full.length; i++) {
        if (this.full[i] == true)
          this.setState({ roomNum: this.state.roomNum + 1 });
        else
          allFull = false;
      }
      if (!allFull)
        this.WaitToJoin();
      else
        console.log("ALL ROOMS ARE FULL")
    }
  }

  //this disconnects from the lobby, is called by checkifempty and a manual disconnect button
  testDisconnect = () => {
    console.log(this.child);
    //NEEDS TO CALL DISCONNECT ON EVERYONE IF YOU QUIT
    //runs disconnect on webrtc
    this.child.current.disconnect();
    //sets entered code to false so it hides the lobby display
    this.exitRoom();
  }

  exitRoom(event) {
    this.setState({ codeInput: false });
    this.setState({ host: false });
    this.setState({ title: "" })
    console.log("Left the Lobby");
  }


  WaitToJoin() {
    this.setState({ searching: true })
    setTimeout(() => {
      console.log(this.child);
      console.log(this.state.roomNum);
      this.child.current.webrtc.joinRoom(this.props.game.service_key + this.state.roomNum);
      //this.checkIfEmpty();
    }, 1)
  }



  ReturnWebrtc() {
    console.log(this.child.current.webrtc);
    return this.child.current.webrtc;
  }

  //this submits the score locally, it does this and also submits the score to the other players
  SubmitScore(score) {
    //var score = (Math.floor(Math.random() * 6));
    console.log(score)
    console.log(this.child);
    console.log(this.child.current);
    console.log(this.child.current.webrtc);
    console.log(this.child.current.webrtccopy)
    var web = this.child.current.webrtc;
    if (web == undefined)
      web = this.child.current.props.webrtc;
    console.log(web);
    //web.shout('test',1)
    web.shout('score', score);

    var scoreObject = {
      username: details.details.school_id,
      score: score
    }

    //find if score exists else create one
    var found = false;
    for (var i = 0; i < this.scores.length; i++) {
      if (this.scores[i].username == details.details.school_id) {
        this.scores[i].score += score;
        console.log(this.scores[i].score)
        found = true;
      }
    }
    if (found == false)
      this.scores.push(scoreObject)

    console.log(this.scores);
  }

  SetScore(score) {
    //sets your score to this
    if (this.child.current != null) {
      var web = this.child.current.webrtc;
      if (web == undefined)
        web = this.child.current.props.webrtc;
      if (web != undefined) {
        web.shout('setscore', score);

        var scoreObject = {
          username: details.details.school_id,
          score: score
        }

        //find if score exists else create one
        var found = false;
        for (var i = 0; i < this.scores.length; i++) {
          if (this.scores[i].username == details.details.school_id) {
            this.scores[i].score = score;
            found = true;
          }
        }
        if (found == false)
          this.scores.push(scoreObject)

        console.log(this.scores);
      }
      console.log("some kind of webrtc is missing error")
    }
  }

  ReturnScores() {
    //add bots to object
    var list = [];
    for (let i = 0; i < this.scores.length; i++) {
      if (this.scores[i].username != "" && this.scores[i].score >= 0)
        list.push(this.scores[i]);
    }
    var botConvert = [];//this converts the bots usernames and names around
    for (let i = 0; i < this.bots.length; i++) {
      let botObj = {
        username: this.bots[i].name,
        score: this.bots[i].score
      }
      botConvert.push(botObj);
    }
    for (let i = 0; i < botConvert.length; i++) {
      list.push(botConvert[i]);
    }

    console.log(this.scores);
    return list;
  }

  HideHeader() {
    this.setState({ header: false });
  }

  RefreshPeers() {
    if (this.state.started) {
      var peers = this.child.current.webrtc.getPeers();//the connected peers
      console.log(peers);
      console.log(this.child);
      //change scores by removing any peers that don't exist

      var removeScoreID = -1;
      for (let i = 0; i < this.scores.length; i++) {
        console.log("Peer: " + peers[i])
        console.log("Score: " + this.scores[i].username)
        if (peers[i] == undefined) {
          removeScoreID = i;
        }
        else if (peers[i].nick != this.scores[i].username)
          removeScoreID = i;

      }
      this.scores[removeScoreID].username = "";
      this.scores[removeScoreID].score = -1;
    }
    this.setState({ update: !this.state.update });//sets to update to refresh the display
  }

  GoBack() {
    this.testDisconnect();
    this.props.goBack();
  }

  render() {
    return (
      <div>
        <LioWebRTC
          ref={this.child}
          nick="test1"
          onReady={this.WaitToJoin.bind(this)}
          onCreatedPeer={this.handleCreatedPeer}
          onReceivedPeerData={this.handlePeerData}
          onJoinedRoom={this.checkIfEmpty}
          onRemovedPeer={this.RefreshPeers.bind(this)}
        ></LioWebRTC>

        {this.state.started == false ? (
          <div>


            {this.state.searching == true ? (
              <div>
                <BodyCode style={{ display: 'flex' }}>
                  <Frame style={{ height: "400px" }}>
                    <h1 style={{ textAlign: "center", position: "relative", top: "40%" }}>{this.loadingText}</h1>
                  </Frame>
            </BodyCode>
              </div>
            ) : (
                <div>
                  <BodyCode style={{ display: 'flex' }}>
                    <Frame style={{ height: "400px" }}>
                      <Button style={{
                        position: "relative",
                        top: "20%",
                        alignSelf: "center",
                        width: "400px",
                        height: "100px",
                        lineHeight: "70px",
                        fontSize: "3em"
                      }} onClick={this.GoBack.bind(this)}>Exit Room</Button>
                      <br>
                      </br>
                      {this.state.readyToStart != false && this.props.host == true ? (
                        <Button style={{
                          position: "relative",
                          top: "25%",
                          alignSelf: "center",
                          width: "400px",
                          height: "100px",
                          lineHeight: "70px",
                          fontSize: "3em"
                        }} onClick={this.StartGame.bind(this)}>{this.state.countDown}</Button>

                      ) : (
                          <GreyedButton2 style={{
                            position: "relative",
                            top: "25%",
                            alignSelf: "center",
                            width: "400px",
                            height: "100px",
                            lineHeight: "70px",
                            fontSize: "3em"
                          }}>{this.state.countDown}</GreyedButton2>
                        )}
                    </Frame>

                  </BodyCode>
                  <BodyCode>
                    <FormContent update={this.state.update} style={{ right: "470px", position: "relative", top: "-444px", width: "400px" }}>
                      <h1>Players</h1>
                      <div>
                        {this.DisplayUsernames()}
                      </div>
                    </FormContent>
                  </BodyCode>

                </div>
              )}
          </div>
        ) :
          (//IF GAME STARTED
            <div>
              <GameMode
                props={this.props}
                testprop={this.child}
                getwebrtc={this.ReturnWebrtc.bind(this)}
                SubmitScore={this.SubmitScore.bind(this)}
                ReturnScores={this.ReturnScores.bind(this)}
                details={details.details}
                webrtccopy={ref => (this.webrtccopy = ref)}
                exitGame={this.testDisconnect.bind(this)}

              >
                game modde
            </GameMode>
            </div>
          )}
      </div>
    )
  }
}

class CodeEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      value: props.value || "",
      codeInput: false,
      host: false,
      header: true
    };
    this.child = React.createRef();
  }

  handleChange(event) {
    this.setState({ title: event.target.value })
  }

  handleKeyPress(event) {
    if (event.which === 13) {
      this.setState({ codeInput: true });
      this.setState({ host: false })
      console.log(this.state);
    }
  }

  createRoom(event) {
    //gets a unique code
    var code = makeid(5);
    console.log(code)
    this.setState({ title: code })
    this.setState({ host: true })
    console.log(this.state);
    this.setState({ codeInput: true });
  }

  joinRoom(event) {
    //gets a unique code
    if (this.state.title != "") {
      this.setState({ codeInput: true });
      this.setState({ host: false })
      console.log(this.state);
    }
  }

  exitRoom(event) {
    this.setState({ codeInput: false });
    this.setState({ host: false });
    this.setState({ title: "" })
    console.log("Left the Lobby");
  }

  HideHeader() {
    this.setState({ header: false });
  }

  GetListOfPlayers(params) {
    //backgroundImage: this.state.header ? `url(${background})` : null
  }

  GoBack() {
    this.props.goBack();
  }

  render() {
    return (
      <div>

        {this.state.codeInput == false ? (
          <BodyCode style={{ display: this.state.header ? 'flex' : 'none' }}>
            <div style={{ justifyContent: 'center', alignSelf: "center" }}>
              <h1 style={{ textAlign: "center" }}>{this.props.game.description}</h1>
              <br></br>
              <div style={{ justifyContent: 'center', alignSelf: "center" }}>
                <div>
                  <Frame style={{ height: "500px" }}>
                    <br></br>
                    <h2 style={{ alignSelf: "center", fontSize: "2em" }}>Enter Code</h2>
                    <input
                      style={{ alignSelf: "center", }}
                      type="text"
                      name="title"
                      value={this.state.title}
                      onChange={this.handleChange.bind(this)}
                      onKeyPress={this.handleKeyPress.bind(this)}
                    />
                    <br></br><br></br>
                    <Button style={{
                      alignSelf: "center",
                      width: "400px",
                      height: "100px",
                      lineHeight: "70px",
                      fontSize: "3em"
                    }} onClick={this.createRoom.bind(this)}>Create Room</Button>
                    <Button style={{
                      alignSelf: "center",
                      width: "400px",
                      height: "100px",
                      lineHeight: "70px",
                      fontSize: "3em"
                    }} onClick={this.joinRoom.bind(this)}>Join Room</Button>
                    <Button style={{
                      alignSelf: "center",
                      width: "400px",
                      height: "100px",
                      lineHeight: "70px",
                      fontSize: "3em"
                    }} onClick={this.GoBack.bind(this)}>Go Back</Button>
                  </Frame>
                </div>
              </div>
            </div>
          </BodyCode>

        ) : (
            <BodyCode>
              <div started={gamestart}>
                {gamestart ? (
                  <div></div>
                ) : (
                    <div>
                      <h1 style={{ textAlign: "center" }}>{this.props.game.description}</h1>
                    </div>
                  )}
                <FormContent style={{ width: "500px", justifyContent: "center", border: this.state.header ? '2px solid #673b8b' : 'none', background: this.state.header ? '#ffffff' : 'none' }}>
                  <MultTest HideHeader={this.HideHeader.bind(this)} roomName={this.state.title} host={this.state.host} exitMethod={this.exitRoom.bind(this)} game={this.props.game} webrtccopy={ref => (this.child = ref)} ></MultTest>
                </FormContent>
              </div>
            </BodyCode>
          )}
      </div>
    );
  }
}


class MultTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chatLog: [],
      options: {
        debug: true,
        dataOnly: true
      },
      update: false,
      started: false,
      readyToStart: false
    };
    this.child = React.createRef();
    this.scores = [];
    this.web = React.createRef();
  }

  join = (webrtc) => webrtc.joinRoom(this.props.game.service_key + this.props.roomName.toLowerCase());
  //exit = (webrtc) => this.webrtc.disconnect();

  //this disconnects from the lobby, is called by checkifempty and a manual disconnect button
  testDisconnect = () => {
    //runs disconnect on webrtc
    this.child.current.disconnect();
    console.log(this.checkIfEmpty)
    //sets entered code to false so it hides the lobby display
    this.props.exitMethod();
  }

  ReturnWebrtc() {
    console.log(this.child.current.webrtc);
    return this.child.current.webrtc;
  }

  ReturnScores() {
    var newScoreList = []
    for (let i = 0; i < this.scores.length; i++) {
      if (this.scores[i].username != "" && this.scores[i].score >= 0)
        newScoreList.push(this.scores[i]);
    }
    //console.log(this.scores);
    return newScoreList;
  }

  //this is done on join
  checkIfEmpty = () => {
    console.log("I joined a room");
    console.log(this.props);
    console.log(details);
    console.log(this.child.current.webrtc);
    //get amount of people in room
    var count = this.child.current.webrtc.roomCount;
    //sets nickname
    this.child.current.webrtc.webrtc.config.nick = details.details.school_id;
    //if the room is empty and you aren't the host then disconnect
    if (count == 1 && this.props.host == false)
      this.testDisconnect();
    else {
      //checks if your name already exists there
      if (count < 8) {
        var duplicate = false;
        this.setState({ scores: [] })
        this.setState({ readyToStart: true })
        this.SetScore(-1);
      } else {
        this.testDisconnect();
        console.log("Full Room")
      }
    }
  }

  handleCreatedPeer = (webrtc, peer) => {
    this.addChat(`Peer-${peer.id.substring(0, 5)} joined the room!`, ' ', true);
    //this.props.webrtc.shout('playerid', "test")
    console.log(this.child.current.webrtc.getPeers());
    console.log(this.child)
    //sets nickname
    this.child.current.webrtc.webrtc.config.nick = details.details.school_id;
    this.setState({ update: false })
    this.setState({ readyToStart: false })
    this.WaitForJoin();
  }

  handlePeerData = (webrtc, type, payload, peer) => {
    console.log(peer);
    console.log(type);
    switch (type) {
      case 'chat':
        this.addChat(`Peer-${peer.id.substring(0, 5)}`, payload);
        break;
      case 'playerID':
        console.log("joined")
        break;
      case 'start':
        gamestart = true;
        this.SetScore(0);
        this.setState({ started: true });
        console.log("host sent start game");
        break;
      case 'ingame':
        console.log("received ingame")
        if (this.state.started == false) {
          console.log("game is already in motion")
          this.testDisconnect();
        }
        break;
      case 'score':
        //parse the payload by adding it to the score
        this.ParseOnlineScore(peer.nick, payload);
        this.setState({ update: !this.update })
        break;
      case 'setscore':
        //parse the payload by adding it to the score
        this.ParseOnlineSetScore(peer.nick, payload);
        this.setState({ update: !this.update })
        break;
      default:
        return;
    };
  }

  //this method adds the score that was sent to this player into the scores list, this makes it so both are sync
  ParseOnlineScore(usernam, score) {
    var scoreObject = {
      username: usernam,
      score: parseInt(score, 10)
    }

    //find if score exists else create one
    var found = false;
    for (var i = 0; i < this.scores.length; i++) {
      if (this.scores[i].username == usernam) {
        this.scores[i].score += score;
        found = true;
      }
    }
    if (found == false)
      this.scores.push(scoreObject)

    console.log(this.scores);
  }

  //this method adds the score that was sent to this player into the scores list, this makes it so both are sync
  ParseOnlineSetScore(usernam, score) {
    var scoreObject = {
      username: usernam,
      score: parseInt(score, 10)
    }

    //find if score exists else create one
    var found = false;
    for (var i = 0; i < this.scores.length; i++) {
      if (this.scores[i].username == usernam) {
        this.scores[i].score = score;
        found = true;
      }
    }
    if (found == false)
      this.scores.push(scoreObject)

    console.log(this.scores);
  }

  WaitForJoin() {
    setTimeout(() => {
      console.log("timer done");
      this.setState({ update: true })
      this.setState({ readyToStart: true })
      if (this.state.started == false)
        this.SetScore(-1);
      if (this.state.started == true) {
        console.log("started is true");
        console.log(this.child.current.webrtc.shout)
        this.child.current.webrtc.shout('ingame', 'blank')
      }
    }, 1500)
  }

  addChat = (name, message, alert = false) => {
    this.setState({
      chatLog: this.state.chatLog.concat({
        name,
        message: `${message}`,
        timestamp: `${Date.now()}`,
        alert
      })
    });
  }

  DisplayUsernames() {
    const numbers = [1, 2, 3, 4, 5];
    console.log(this.child.current.webrtc.peers);
    console.log(this.child.current.webrtc.getPeers())
    var peers = this.child.current.webrtc.getPeers();
    var list = [];
    //push your name
    list.push(details.details.school_id);
    if (peers != undefined && peers.length > 0) {
      for (let index = 0; index < peers.length; index++) {
        console.log(peers[index])
        console.log(peers[index].id)
        console.log(peers[index].nick)
        console.log(peers[index].type)
        list.push(peers[index].nick);
      }
    }
    console.log(list);

    const listItems = list.map((i) =>
      <li style={{ fontSize: "2em" }}>{i}</li>
    );
    return listItems;
  }

  //ISSUE IS WITH THE SUBMIT
  //this submits the score locally, it does this and also submits the score to the other players
  SubmitScore(score) {
    //var score = (Math.floor(Math.random() * 6));
    console.log(score)
    console.log(this.child);
    console.log(this.child.current);
    console.log(this.child.current.webrtc);
    console.log(this.child.current.webrtccopy)
    var web = this.child.current.webrtc;
    if (web == undefined)
      web = this.child.current.props.webrtc;
    if (web != undefined) {
      console.log(web);
      //web.shout('test',1)
      web.shout('score', score);

      var scoreObject = {
        username: details.details.school_id,
        score: score
      }

      //find if score exists else create one
      var found = false;
      for (var i = 0; i < this.scores.length; i++) {
        if (this.scores[i].username == details.details.school_id) {
          this.scores[i].score += score;
          console.log(this.scores[i].score)
          found = true;
        }
      }
      if (found == false)
        this.scores.push(scoreObject)

      console.log(this.scores);
    }
  }

  SetScore(score) {
    //sets your score to this
    if (this.child.current != null) {
      var web = this.child.current.webrtc;
      if (web == undefined)
        web = this.child.current.props.webrtc;
      if (web != undefined) {
        web.shout('setscore', score);

        var scoreObject = {
          username: details.details.school_id,
          score: score
        }

        //find if score exists else create one
        var found = false;
        for (var i = 0; i < this.scores.length; i++) {
          if (this.scores[i].username == details.details.school_id) {
            this.scores[i].score = score;
            found = true;
          }
        }
        if (found == false)
          this.scores.push(scoreObject)

        console.log(this.scores);
      }
      console.log("some kind of webrtc is missing error")
    }
  }

  StartGame() {
    if (this.props.host) {
      console.log("started game");
      gamestart = true
      this.child.current.webrtc.shout('start', "");
      console.log(gamestart);
      this.SetScore(0);
      this.setState({ started: true });
    }

  }

  GetPeerCount() {
    if (this.child.current != null) {
      return this.child.current.webrtc.getPeers().length;
    }
    return 0;
  }

  DebugNickName() {
    console.log(this.child.current.webrtc.getPeers()[0].nick);

    return (
      <div>
        {this.child.current.webrtc.getPeers()[0].nick}
      </div>
    );
  }

  RefreshPeers() {
    if (this.state.started) {
      var peers = this.child.current.webrtc.getPeers();//the connected peers
      console.log(peers);
      console.log(this.child);
      //change scores by removing any peers that don't exist
      var removeScoreID = -1;
      for (let i = 0; i < this.scores.length; i++) {
        console.log("Peer: " + peers[i])
        console.log("Score: " + this.scores[i].username)
        if (peers[i] == undefined) {
          removeScoreID = i;
        }
        else if (peers[i].nick != this.scores[i].username)
          removeScoreID = i;

      }
      this.scores[removeScoreID].username = "";
    }else{
      console.log("refreshing peers");
      //if no peers and not host then disconnect
      var peers = this.child.current.webrtc.getPeers();
      console.log(peers);
      if (peers.length == 0 && this.props.host == false){
        console.log("KICK ME OUT");
        this.testDisconnect();
      }
    }
    
    this.setState({ update: !this.state.update });//sets to update to refresh the display
  }

  render() {
    console.log(this.props)

    const { chatLog, options } = this.state;
    return (
      <div className="App" gameState={this.state}>
        <div>

          <LioWebRTC
            ref={this.child}
            nick="test1"
            options={options}
            onReady={this.join}
            onCreatedPeer={this.handleCreatedPeer}
            onReceivedPeerData={this.handlePeerData}
            onJoinedRoom={this.checkIfEmpty}
            onRemovedPeer={this.RefreshPeers.bind(this)}
          >
            {gamestart == false ? (
              <div>
                <h1 style={{ fontSize: "3em", textAlign: "center" }} className="title">Code: {this.props.roomName.toUpperCase()}</h1>
                <Button style={{
                  alignSelf: "center",
                  width: "400px",
                  height: "100px",
                  lineHeight: "70px",
                  fontSize: "3em"
                }} onClick={this.testDisconnect}>Exit Room</Button>

                <br>
                </br>
                {this.state.readyToStart != false && this.props.host == true && this.GetPeerCount() > 0 ? (
                  <Button style={{
                    alignSelf: "center",
                    width: "400px",
                    height: "100px",
                    lineHeight: "70px",
                    fontSize: "3em"
                  }} onClick={this.StartGame.bind(this)}>Start Game</Button>

                ) : (
                    <GreyedButton2 style={{
                      alignSelf: "center",
                      width: "400px",
                      height: "100px",
                      lineHeight: "70px",
                      fontSize: "3em"
                    }}>Start Game</GreyedButton2>

                  )}

              </div>
            ) : (
                <div></div>
              )}
          </LioWebRTC>
          {gamestart == false ? (
            <div>
              <FormContent update={this.state.update} style={{ right: "450px", position: "relative", top: "-280px", width: "400px" }}>
                <h1>Players</h1>
                {this.state.update == false ? (
                  <div>
                    <li style={{ fontSize: "2em" }}>{details.details.school_id}</li>
                  </div>
                ) : (
                    <div>
                      {this.DisplayUsernames()}
                    </div>
                  )}
              </FormContent>
            </div>
          ) : (
              <GameMode
                props={this.props}
                testprop={this.child}
                getwebrtc={this.ReturnWebrtc.bind(this)}
                SubmitScore={this.SubmitScore.bind(this)}
                ReturnScores={this.ReturnScores.bind(this)}
                details={details.details}
                webrtccopy={ref => (this.webrtccopy = ref)}
                exitGame={this.testDisconnect.bind(this)}
              >
                game modde
          </GameMode>
            )}
        </div>
      </div>
    );
  }
}

/*
const WrappedLio = React.forwardRef((props,ref)=>{
  return <LioExtended {...props}forwardedRef={ref}>

  </LioExtended>
})
class LioExtended extends React.Component{
  componentDidUpdate(prevProps) {
    console.log('old props:', prevProps);
    console.log('new props:', this.props);
  }

  render() {
    const {forwardedRef, ...rest} = this.props;

    // Assign the custom prop "forwardedRef" as a ref
    return <LioWebRTC ref={forwardedRef} {...rest} />;
  }
}

const LioWebRTCExtended = Component =>{
  const forwardRef = function(props,ref){
    return <LioWebRTC forwardedRef={ref}>

    </LioWebRTC>

  }
  return React.forwardRef(forwardRef);
}*/

class GameMode extends Component {
  constructor(props) {
    super(props);
    this.scores = [];
  }

  componentDidMount() {
    if (this.props.props.HideHeader != undefined)
      this.props.props.HideHeader();
    console.log("first time render sets props")
    console.log(this.props);
  }

  componentDidUpdate(prevProps) {
    console.log('old props:', prevProps);
    console.log('new props:', this.props);
  }

  endGame() {
    this.props.onEnd && this.props.onEnd();
    //load multiplayer screen
    console.log(this.props);
    var gameid = this.props.props.game.id;
    this.props.exitGame();
    navigate("/games/" + gameid);
  }

  Submit() {

  }

  render() {
    console.log(this.props);
    /*
    return (
      <div>
        I am rating game
      </div>
    );*/

    if (this.props.props.game.id == 9) {
      return (
        <div style={{ position: 'absolute', left: "0px", top: "0px" }}>
          I am game mode
        <MultiplyDivide {...this.props}
            ref={this.props.forwardRef}
            parent={this.props}
            homework_id={this.props.homework_id}
            onBack={() => this.endGame()}
            gameType={this.props.props.game.game_type}
            topics=""
            gameBackground={this.props.props.game.practice_background}
            level="0"
            game={this.props.props.game}
          >
          </MultiplyDivide>
        </div>
      );
    }
    if (this.props.props.game.id == 14) {
      return (
        <div style={{ position: 'absolute', left: "0px", top: "0px" }}>
          I am game mode
        <Addition {...this.props}
            ref={this.props.forwardRef}
            parent={this.props}
            homework_id={this.props.homework_id}
            onBack={() => this.endGame()}
            gameType={this.props.props.game.game_type}
            topics=""
            gameBackground={this.props.props.game.practice_background}
            level="0"
            game={this.props.props.game}
          >
          </Addition>
        </div>
      );
    }
    if (this.props.props.game.id == 12) {
      return (
        <div style={{ position: 'absolute', left: "0px", top: "0px" }}>
          I am game mode
        <Fractions {...this.props}
            ref={this.props.forwardRef}
            parent={this.props}
            homework_id={this.props.homework_id}
            onBack={() => this.endGame()}
            gameType={this.props.props.game.game_type}
            topics=""
            gameBackground={this.props.props.game.practice_background}
            level="0"
            game={this.props.props.game}
          >
          </Fractions>
        </div>
      );
    }
    if (this.props.props.game.id == 10) {
      return (
        <div style={{ position: 'absolute', left: "0px", top: "0px" }}>
          <Spelling {...this.props}
            ref={this.props.forwardRef}
            parent={this.props}
            homework_id={this.props.homework_id}
            onBack={() => this.endGame()}
            gameType={this.props.props.game.game_type}
            topics=""
            gameBackground={this.props.props.game.practice_background}
            level="0"
            game={this.props.props.game}
          >
          </Spelling>
        </div>
      );
    }
    if (this.props.props.game.id == 16) {
      return (
        <div style={{ position: 'absolute', left: "0px", top: "0px" }}>
          <NumPlace {...this.props}
            ref={this.props.forwardRef}
            parent={this.props}
            homework_id={this.props.homework_id}
            onBack={() => this.endGame()}
            gameType={this.props.props.game.game_type}
            topics=""
            gameBackground={this.props.props.game.practice_background}
            level="0"
            game={this.props.props.game}
          >
          </NumPlace>
        </div>
      );
    }
    if (this.props.props.game.id == 21) {
      return (
        <div style={{ position: 'absolute', left: "0px", top: "0px" }}>
          <RomanNumerals {...this.props}
            ref={this.props.forwardRef}
            parent={this.props}
            homework_id={this.props.homework_id}
            onBack={() => this.endGame()}
            gameType={this.props.props.game.game_type}
            topics=""
            gameBackground={this.props.props.game.practice_background}
            level="0"
            game={this.props.props.game}
          >
          </RomanNumerals>
        </div>
      );
    }
    if (this.props.props.game.id == 17) {
      return (
        <div style={{ position: 'absolute', left: "0px", top: "0px" }}>
          <Algebra {...this.props}
            ref={this.props.forwardRef}
            parent={this.props}
            homework_id={this.props.homework_id}
            onBack={() => this.endGame()}
            gameType={this.props.props.game.game_type}
            topics=""
            gameBackground={this.props.props.game.practice_background}
            level="0"
            game={this.props.props.game}
          >
          </Algebra>
        </div>
      );
    }
    if (this.props.props.game.id == 13) {
      return (
        <div style={{ position: 'absolute', left: "0px", top: "0px" }}>
          <Grammar {...this.props}
            ref={this.props.forwardRef}
            parent={this.props}
            homework_id={this.props.homework_id}
            onBack={() => this.endGame()}
            gameType={this.props.props.game.game_type}
            topics=""
            gameBackground={this.props.props.game.practice_background}
            level="0"
            game={this.props.props.game}
          >
          </Grammar>
        </div>
      );
    }
    if (this.props.props.game.id == 11) {
      return (
        <div style={{ position: 'absolute', left: "0px", top: "0px" }}>
          <Geometry {...this.props}
            ref={this.props.forwardRef}
            parent={this.props}
            homework_id={this.props.homework_id}
            onBack={() => this.endGame()}
            gameType={this.props.props.game.game_type}
            topics=""
            gameBackground={this.props.props.game.practice_background}
            level="0"
            game={this.props.props.game}
          >
          </Geometry>
        </div>
      );
    }
    if (this.props.props.game.id == 15) {
      return (
        <div style={{ position: 'absolute', left: "0px", top: "0px" }}>
          <Measurements {...this.props}
            ref={this.props.forwardRef}
            parent={this.props}
            homework_id={this.props.homework_id}
            onBack={() => this.endGame()}
            gameType={this.props.props.game.game_type}
            topics=""
            gameBackground={this.props.props.game.practice_background}
            level="0"
            game={this.props.props.game}
          >
          </Measurements>
        </div>
      );
    }
    if (this.props.props.game.id == 19) {
      return (
        <div style={{ position: 'absolute', left: "0px", top: "0px" }}>
          <Statistics {...this.props}
            ref={this.props.forwardRef}
            parent={this.props}
            homework_id={this.props.homework_id}
            onBack={() => this.endGame()}
            gameType={this.props.props.game.game_type}
            topics=""
            gameBackground={this.props.props.game.practice_background}
            level="0"
            game={this.props.props.game}
          >
          </Statistics>
        </div>
      );
    }
    if (this.props.props.game.id == 26) {
      return (
        <div style={{ position: 'absolute', left: "0px", top: "0px" }}>
          <Phonics {...this.props}
            ref={this.props.forwardRef}
            parent={this.props}
            homework_id={this.props.homework_id}
            onBack={() => this.endGame()}
            gameType={this.props.props.game.game_type}
            topics=""
            gameBackground={this.props.props.game.practice_background}
            level="0"
            game={this.props.props.game}
          >
          </Phonics>
        </div>
      );
    }
      if (this.props.props.game.id == 27) {
        return (
          <div style={{ position: 'absolute', left: "0px", top: "0px" }}>
            <NumberSense {...this.props}
              ref={this.props.forwardRef}
              parent={this.props}
              homework_id={this.props.homework_id}
              onBack={() => this.endGame()}
              gameType={this.props.props.game.game_type}
              topics=""
              gameBackground={this.props.props.game.practice_background}
              level="0"
              game={this.props.props.game}
            >
            </NumberSense>
          </div>
        );
    }
    if (this.props.props.game.id == 20) {
      return (
        <div style={{ position: 'absolute', left: "0px", top: "0px" }}>
          <Ratios {...this.props}
            ref={this.props.forwardRef}
            parent={this.props}
            homework_id={this.props.homework_id}
            onBack={() => this.endGame()}
            gameType={this.props.props.game.game_type}
            topics=""
            gameBackground={this.props.props.game.practice_background}
            level="0"
            game={this.props.props.game}
          >
          </Ratios>
        </div>
      );
  }
  if (this.props.props.game.id == 30) {
    return (
      <div style={{ position: 'absolute', left: "0px", top: "0px" }}>
        <MathsVocab {...this.props}
          ref={this.props.forwardRef}
          parent={this.props}
          homework_id={this.props.homework_id}
          onBack={() => this.endGame()}
          gameType={this.props.props.game.game_type}
          topics=""
          gameBackground={this.props.props.game.practice_background}
          level="0"
          game={this.props.props.game}
        >
        </MathsVocab>
      </div>
    );
}
  }
}

function CreateList(peers) {

}

const Buttonz = styled.button`
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  width: 20%;
  border: 2px solid #e88f12;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: -0.5em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`

const Body = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${background});
  background-size: cover;
  background-position: 0px -1px;
  display: flex;
  justify-content: center;
  padding-top: 40px;
`;

const BodyCode = styled.div`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: repeat;
  background-size: cover;
  background-position: 0px 0px;
  display: flex;
  justify-content: center;
  padding-top: 40px;
  
`;

const Frame = styled.div`
  width: 500px;
  height: 600px;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 10px;
  display: relative;
  border: 2px solid #673b8b;

  input {
    width: 85%;
    padding: 1em;
    background: #eeeaf5;
    border: 2px solid #af9dc4;
    border-radius: 0.5em;
    justify-content: center;
    font-size: 2em;
    color: #af9dc4;
  }

  h2 {
    color: #673b8b;
    font-size: 2em;
    margin: 0.25em;
  }
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 2px solid #673b8b;
  border-radius: 1em;

  h1 {
    color: #673b8b;
    font-size: 4em;
    margin: 0.25em;
  }


`;

const CenteredContainer = styled.div`
  width: 100%;
  max-width: 768px;
  padding: 2.5em;
  box-sizing: border-box;
`;

const Button = styled.div`
  text-align: center;
  width: 100%;
  height: 150px;
  line-height: 100px;
  font-size: 4em;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const GreyedButton2 = styled.div`
  text-align: center;
  width: 100%;
  height: 150px;
  line-height: 100px;
  font-size: 4em;
  margin: 5px;
  color: #fff;
  background: rgb(195, 195, 195);
  background: linear-gradient(
    0deg,
    rgb(195, 195, 195) 0%,
    rgb(150, 150, 150) 100%
  );
  border: 2px solid #a0a0a0;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

